import { IconFlag } from "@tabler/icons-react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

import { Text } from "components";
import { RouteConstants } from "constant";
import useDashboardTodoStats from "pages/dashboard/shared/useDashboardTodoStats";

import classes from "./TodoWidgetSection.module.css";

interface TodoWidgetSectionProps {
  className?: string;
}

const { ROUTE_TODO } = RouteConstants;

const TodoWidgetSection = ({ className }: TodoWidgetSectionProps) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { totalCount, urgentCount, importantCount } = useDashboardTodoStats();
  const hasPriorityItems = urgentCount > 0 || importantCount > 0;

  return (
    <button
      type="button"
      className={[classes.root, className].filter(Boolean).join(" ")}
      onClick={() => navigate(ROUTE_TODO)}
      aria-label={t("dashboard.todo.title")}
    >
      <Text className={classes.title}>{t("dashboard.todo.title")}</Text>
      <div className={classes.body}>
        <Text className={classes.totalValue}>{totalCount}</Text>

        {hasPriorityItems ? (
          <div className={classes.priorityPill}>
            {importantCount > 0 ? (
              <div className={classes.priorityItem}>
                <Text className={classes.priorityValue}>{importantCount}</Text>
                <IconFlag
                  className={classes.importantFlag}
                  size={18}
                  stroke={2}
                  aria-hidden="true"
                />
              </div>
            ) : null}

            {urgentCount > 0 ? (
              <div className={classes.priorityItem}>
                <Text className={classes.priorityValue}>{urgentCount}</Text>
                <IconFlag
                  className={classes.urgentFlag}
                  size={18}
                  stroke={2}
                  aria-hidden="true"
                />
              </div>
            ) : null}
          </div>
        ) : null}
      </div>
    </button>
  );
};

export default TodoWidgetSection;
